var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-btn-box"},[_c('input',{ref:"clearFile",staticClass:"photoinput",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadphoto}}),_c('i',{staticClass:"el-icon-circle-plus-outline"})])}
var staticRenderFns = []

export { render, staticRenderFns }